import { render, staticRenderFns } from "./bidding-list.vue?vue&type=template&id=dfc04d76&scoped=true"
import script from "./bidding-list.vue?vue&type=script&lang=js"
export * from "./bidding-list.vue?vue&type=script&lang=js"
import style0 from "./bidding-list.vue?vue&type=style&index=0&id=dfc04d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc04d76",
  null
  
)

export default component.exports